<script lang="ts" setup>
import { ref } from 'vue';

import { KaButton } from '@/kasten-components/components/KaButton';
import type { MaybePromise } from '@/kasten-components/types';

import { injectMultiStepFormContext, type Step } from './model';

const {
  onFirst: onTriggerFirst,
  isFirstStep,
  isLastStep,
  prevStep,
  currentStep,
} = injectMultiStepFormContext();

const props = defineProps<{
  onJump: (currentStep: Step, prevStep?: Step) => MaybePromise<boolean>;
}>();

const loading = ref(false);

const handleClick = async () => {
  loading.value = true;
  if (await props.onJump(currentStep.value, prevStep.value)) {
    onTriggerFirst();
  }
  loading.value = false;
};
</script>
<template>
  <KaButton
    class="max-sm:flex-grow"
    :loading="loading"
    data-testid="multiStepBack"
    @click="handleClick"
  >
    <slot :loading="loading" :last-step="isLastStep" :first-step="isFirstStep">
      Jump to first
    </slot>
  </KaButton>
</template>
